<template>
  <q-card>
    <q-card-section>
      <div class="title">Datos del índice</div>
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
          <!-- Input Nombre -->
          <div class="row input">
            <q-input
              class="col-12"
              data-cy="name-indice-tematico"
              label="*Nombre"
              outlined
              v-model.trim="$v.name.$model"
              :error="$v.name.$error"
            >
              <template v-slot:error>
                <span data-cy="name-indice-tematico-error">Dato obligatorio.</span>
              </template>
            </q-input>
          </div>
          <!-- Input Orden -->
          <div class="row input">
            <q-input
              class="col-12"
              data-cy="order-indice-tematico"
              label="*Orden"
              min="0"
              outlined
              type="number"
              v-model="$v.order.$model"
              :error="$v.order.$error"
            >
              <template v-slot:error>
                <span data-cy="order-indice-tematico-error">Dato obligatorio.</span>
              </template>
            </q-input>
          </div>
          <!-- Visible Toggle button -->
          <div class="row toggle">
            <q-toggle
              color="primary"
              data-cy="toggle-visible-indice-tematico"
              v-model="visible"
              :label="visible?'Visible en listado':'No visible en el listado'"
            />
          </div>
        </div>
        <div class="image col-12 col-sm-4 col-md-4 col-lg-3 col-xl-2">
          <UploadImage
            data-cy="uploadImg"
            label="CAMBIAR IMAGEN"
            v-model="indiceTematicoImage"
            :showPreview="{
              show: true,
              sizes: {
                width: '137px',
                height: '137px',
              },
              ratio: 16 / 9,
            }"
          />
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import { QCard, QCardSection, QToggle } from 'quasar';
import { required } from 'vuelidate/lib/validators';
import Resources from '@/components/shared/mixins/Resources.js';
import UploadImage from '@/shared/uploadImage/components/UploadImage.vue';

export default {
  components: {
    QCard,
    QCardSection,
    QToggle,
    UploadImage
  },
  props: {
    indiceTematico: Object
  },
  mixins: [Resources],
  data () {
    return {
      name: '',
      order: null,
      visible: true,
      indiceTematicoImage: null
    };
  },
  validations: {
    name: { required },
    order: { required }
  },
  watch: {
    indiceTematico: function () {
      if (this.indiceTematico) {
        this.name = this.indiceTematico.name;
        this.order = this.indiceTematico.order;
        this.visible = this.indiceTematico.visible;
        this.indiceTematicoImage = this.indiceTematico.file.length !== 0
          ? this.searchResource(this.indiceTematico.file, 'imagen').url
          : null;
      }
    }
  },
  mounted () {
    this.$eventHub.$on('SAVE_INDICE_TEMATICO',
      ({ callback, reject }) => this.saveIndiceTematico(callback, reject));
  },
  beforeDestroy () {
    this.$eventHub.$off('SAVE_INDICE_TEMATICO');
  },
  methods: {
    saveIndiceTematico (callback, reject) {
      // Validación de los datos
      this.$v.$touch();
      if (this.$v.$error) return reject();

      let data = {
        name: this.name,
        order: this.order,
        visible: this.visible,
        file: this.indiceTematicoImage
      };
      callback(data);
    }
  }
};
</script>

<style lang="scss" scoped>
  .q-card {
    padding: 15px 30px;
    .title {
      font-size: 20px;
      letter-spacing: 0.29px;
      margin-bottom: 32px;
    }
    .input {
      margin-bottom: 32px;
    }
    .image {
      margin-left: 2rem;
    }
  }
  .toggle {
    margin-top: 20px;
  }
</style>
